import React from 'react';
import styled from 'styled-components';

const CourseCardWrapperStyled = styled.div`
  width: 100%;
  height: 100%;
  max-width: ${(props) => (props.$inGrid ? '100%' : '375px')};
  max-height: 640px; //needed for course settings so it does not grow indefetly
  position: relative;
  box-shadow: ${(props) => props.theme.shadows.BOX_SHADOW_MINI};
  display: flex;
  border-radius: 16px;
  flex-direction: column;
  overflow: hidden;
  padding: ${({ $module }) => $module === 'dashboard' && '10px'};
`;

const CourseCardWrapper = ({ children, onClick, inGrid, module, draftCourses }) => {
  return (
    <CourseCardWrapperStyled onClick={onClick} $inGrid={inGrid} $module={draftCourses && module}>
      {children}
    </CourseCardWrapperStyled>
  );
};

export default CourseCardWrapper;
